var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Bar from './Bar';
import { prepareDiagramData2D } from '../basics/Statistics';
import { setOrDef, setIfDef } from '../Helpers';
var PictorialBar = /** @class */ (function (_super) {
    __extends(PictorialBar, _super);
    function PictorialBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            data: undefined,
        };
        _this.calcData = function (props) {
            var dp = props.diagram;
            var stacked = dp.stacked ? true : false;
            prepareDiagramData2D(props.diagram, {
                type: "pictorialBar",
                symbolClip: true,
                symbolBoundingData: 150,
                stack: stacked ? "1" : undefined,
                label: dp.label && dp.label.show ?
                    {
                        normal: {
                            show: true,
                            position: setOrDef(dp.label, function (x) { return x.position; }, "top"),
                            formatter: setIfDef(dp.label, function (x) { return _this.getLabelFormatter(x); }),
                            rich: setIfDef(dp.label, function (x) { return x.rich; })
                        }
                    } : undefined
            }).then(function (data) {
                //                console.log(data);
                _this.setState({ data: data });
                if (_this.props.onFieldsLoaded)
                    _this.props.onFieldsLoaded(data.fields);
            });
        };
        _this.getOption = function () {
            var _a;
            var d = _this.props.diagram;
            if (!_this.state.data)
                return undefined;
            var option = __assign(__assign({ backgroundColor: d.backgroundColor, color: d.colors ? d.colors.colors : undefined, 
                /*            dataset: {
                                source: this.state.data.data
                            },*/
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    formatter: (_a = d.tooltip) === null || _a === void 0 ? void 0 : _a.formatter,
                    axisPointer: d.showAxisPointer ? {
                        type: "shadow"
                    } : undefined
                }, grid: {
                    show: true,
                    left: setOrDef(d.margin, function (x) { return x.left; }, 0),
                    right: setOrDef(d.margin, function (x) { return x.right; }, 0),
                    bottom: setOrDef(d.margin, function (x) { return x.bottom; }, 0),
                    top: 10 + (setOrDef(d.margin, function (x) { return x.top; }, 0)),
                    containLabel: true,
                    backgroundColor: 'transparent',
                    borderWidth: 0
                } }, _this.getBaseOption()), { series: _this.mapData() });
            //        console.log(option);
            return option;
        };
        _this.mapData = function () {
            //        console.log(this.state.data);
            if (_this.state.data) {
                return _this.state.data.data.series;
            }
            return undefined;
        };
        return _this;
    }
    return PictorialBar;
}(Bar));
export default PictorialBar;
//# sourceMappingURL=PictorialBar.js.map